import React from 'react';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function PlusRegularIcon(props) {
  return <FontAwesomeIcon icon={faPlus} {...props} />;
}
